import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navigation } from 'components/navigation';
import { Auth, AuthLogout, ProtectedRoute } from 'components/auth';
import { DashboardCard } from 'components/dashboardCard';
import { DeviceDebug } from 'components/device';
import { Flow } from 'components/flow';
import { Notification } from 'components/notification';
import { StatusBar } from 'components/statusBar';
import { TriggerDebug } from 'components/trigger';
import { Settings } from 'components/settings';
import Provider from 'store';

function App() {
	return (
		<BrowserRouter>
			<Provider>
				<div className="flex flex-col min-h-screen">
					<Navigation />
					<Notification />

					<div className="flex-1" style={{ paddingTop: '52px' }}>
						<StatusBar />
						<Routes>
							<Route path="/auth/logout" element={<AuthLogout />} />
							<Route path="/auth" element={<Auth />} />
							<Route
								path="/flows"
								element={
									<ProtectedRoute>
										<Flow />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/device/debug"
								element={
									<ProtectedRoute>
										<DeviceDebug />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/trigger/debug"
								element={
									<ProtectedRoute>
										<TriggerDebug />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/settings"
								element={
									<ProtectedRoute>
										<Settings />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/"
								element={
									<ProtectedRoute>
										<DashboardCard />
									</ProtectedRoute>
								}
							/>
							<Route
								path="/dashboardCard"
								element={
									<ProtectedRoute>
										<DashboardCard />
									</ProtectedRoute>
								}
							/>
						</Routes>
					</div>

					<footer className="border-t border-[--color-border-subtle] bg-[--color-bg-primary] py-3">
						<div className="max-w-7xl mx-auto px-6">
							<span className="text-xs text-[--color-text-tertiary]">
								Go with the flow!
							</span>
						</div>
					</footer>
				</div>
			</Provider>
		</BrowserRouter>
	);
}

export default App;
